import Navbar from "../../components/feature/Navbar";
import Footer from "../../components/feature/Footer";
import HeroSection from "./components/HeroSection";
import ConceptSection from "./components/ConceptSection";
import SystemSection from "./components/SystemSection";
import MenuSection from "./components/MenuSection";
import QASection from "./components/QASection";
import AccessSection from "./components/AccessSection";
import CompanySection from "./components/CompanySection";
import BannerSection from "./components/BannerSection";

export default function Home() {
  return (
    <div className="min-h-screen bg-warm-950">
      <Navbar />
      <main>
        <HeroSection />
        <ConceptSection />
        <SystemSection />
        <MenuSection />
        <QASection />
        <AccessSection />
        <BannerSection />
        <CompanySection />
      </main>
      <Footer />
    </div>
  );
}